<template>
  <div class="brandValuesList">
    <btn
      v-for="brand_value in brandList"
      :key="brand_value"
      :disabled="true"
      button-type="tag"
      class="button-green mb-5 trans"
    >
      <template #icon>
        <brand-value-icon class="mr-10" :name="brand_value" />
      </template>
      {{ displayBrandValue(brand_value) }}
    </btn>
  </div>
</template>
<script>
export default {
  name: "BrandValuesList",
  props: {
    brandList: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  methods: {
    displayBrandValue(brandValue) {
      let result = brandValue;
      if (brandValue === "CHARITABLE_BRAND_GIVE_BACK") {
        result = "Gives back";
      } else if (brandValue === "MINORITY_OWNED_BUSINESS") {
        result = "Minority-Owned";
      } else if (brandValue === "ETHICAL_PRODUCTION") {
        result = "Ethically Produced";
      }
      return result.toLowerCase().split("_").join(" ");
    },
  },
};
</script>
